import { z } from 'zod';
// AnalyticsEvent schema
export const AnalyticsEventSchema = z.object({
    type: z.enum(['search', 'click', 'view', 'add_to_cart', 'conversion']),
    timestamp: z.number(),
    data: z.object({
        query: z.string().optional(),
        productId: z.string().optional(),
        position: z.number().optional(),
        queryID: z.string().optional(),
        userToken: z.string().optional(),
        value: z.number().optional(),
    }),
});
// Compile-time check
const _eventCheck = {};
const _eventCheck2 = {};
